import { Box, Button, Typography, theme } from '@dtx-company/design-system/src'
import { DashboardSlug } from '../../types/reports.types'
import { FC, useCallback, useMemo } from 'react'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { useRouter } from 'next/router'
import flowlyticsEvents from '@dtx-company/inter-app/src/event-tracking/events/flowlytics'
import styled from '@emotion/styled'

const Container = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  width: 100%;
  background-color: ${theme.palette.container.info};
`

const TextButton = styled(Button)`
  padding: 0;
  text-decoration: underline;

  :hover {
    background-color: transparent;
    text-decoration: underline;
  }
`

export const ReportsDataFreshnessBanner: FC = () => {
  const router = useRouter()

  const redirectDestination = useMemo(() => {
    switch (router.query.dashboard_slug) {
      case DashboardSlug.FLOWCODE_ANALYSIS:
        return Routes.ANALYTICS_CODES
      case DashboardSlug.FLOWCODE_RAW_EVENTS:
        return Routes.ANALYTICS_CODES
      case DashboardSlug.FLOWPAGE_ANALYSIS:
        return Routes.ANALYTICS_PAGES
      case DashboardSlug.FLOWPAGE_RAW_EVENTS:
        return Routes.ANALYTICS_PAGES
      default:
        return Routes.ANALYTICS
    }
  }, [router.query.dashboard_slug])

  const handleClick = useCallback((): void => {
    flowlyticsEvents.Flowlytics_Reports_Clicked_DataFreshnessCTA()
    router.push(redirectDestination)
  }, [router, redirectDestination])

  return (
    <Container sx={{ padding: 4 }}>
      <Typography>Reports data may be up to 24 hours delayed, please navigate to our</Typography>
      <Spacer mr={1} />
      <TextButton variant="text" onClick={handleClick}>
        <Typography>real-time dashboard</Typography>
      </TextButton>
      <Spacer mr={1} />
      <Typography>for up-to-date metrics.</Typography>
    </Container>
  )
}
